module.exports = __webpack_public_path__ + "static/media/continuous_review.e976cbb2.svg";